import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main/main.component';
import { SiderComponent } from './sider/sider.component';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { TranslateModule } from '@ngx-translate/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { MainMobileComponent } from './main-mobile/main-mobile.component';
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzAlertModule } from "ng-zorro-antd/alert";
// Deep import, NOT '@beautyapp/cashier': that barrel's index.ts also
// `export *`s cashier.module/cashier.component, which transitively reach
// CashierTourService and its module-scope driver.js import. LayoutModule is
// eagerly bootstrapped (app.config.ts), so importing the full barrel here
// pulled driver.js into an eagerly-modulepreloaded chunk for every page, not
// just the lazy /cashier route.
import { CashierFacade } from "@beautyapp/cashier/services/cashier.facade";
import { NgxsModule } from "@ngxs/store";
import { EmployeeState } from "@beautyapp/core";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzFlexDirective } from 'ng-zorro-antd/flex';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NzGridModule,
        NzLayoutModule,
        NzButtonModule,
        NzDropDownModule,
        NzIconModule,
        NgxPermissionsModule,
        TranslateModule,
        NzSelectModule,
        FormsModule,
        NzSpaceModule,
        NzAlertModule,
        NgxsModule.forFeature([EmployeeState]),
        NzBadgeModule,
        NzTooltipDirective,
        NzFlexDirective,
        SiderComponent, MainMobileComponent
    ],
    exports: [SiderComponent, MainMobileComponent],
    providers: [
        CashierFacade
    ]
})
export class LayoutModule {}
